// A theme family: a name and two variants, light and dark. The variants fill Mantine's two colour
// scheme slots, so the header's sun or moon switches between them exactly as it does today, and a
// family changes only which light and which dark the app shows. Created.ai is today's look: its
// variants are tokens.ts itself, byte for byte (spec web/themes-engine).

/** The colours a variant is made from; derive.ts makes every themed token from them. */
export interface Seeds {
  /** The page behind the content, and the cards, panels and menus on it. */
  page: string;
  surface: string;
  /** A row or an item under the pointer. */
  hover: string;
  border: string;
  /** Body text, headings and quieter text. */
  text: string;
  strong: string;
  muted: string;
  /** The primary action's fill and the text on it; the primary colour as text; links. */
  primary: string;
  onPrimary: string;
  textPrimary: string;
  link: string;
  danger: string;
  warning: string;
  success: string;
  info: string;
  /** The keyboard focus ring. */
  ring: string;
  /** The accent gradient's two ends. */
  from: string;
  to: string;
}

export type Scheme = "light" | "dark";

/** A family made from seeds: a JSON file in families/, its colours read from upstream files. */
export interface SeededFamily {
  id: string;
  name: string;
  /** Where its colours come from: the upstream project, files and licence. */
  source: string;
  light: Seeds;
  dark: Seeds;
}

export const CREATED_ID = "created";

/** Created.ai, today's look, which tokens.ts holds. */
export interface CreatedFamily {
  id: typeof CREATED_ID;
  name: string;
}

export type ThemeFamily = CreatedFamily | SeededFamily;

export function isSeeded(family: ThemeFamily): family is SeededFamily {
  return family.id !== CREATED_ID;
}
